<template>
  <div>
    <div v-if="campaignsWithMaterials.length > 0">
      <v-row
        v-for="{ campaign, materials: campaignMaterials } in campaignsWithMaterials"
        :key="campaign.id"
      >
        <v-col>
          <StaticCard
            :campaign="campaign"
            :materials="campaignMaterials"
            :country="company.country"
          />
        </v-col>
      </v-row>
    </div>
    <UpgradeCard
      v-if="isLight"
      :icon-spacing="100"
      :cta="$t('landingpages.download-tab.upgrade-card.static-tab.cta')"
      :title="$t('landingpages.download-tab.upgrade-card.static-tab.title')"
    >
      <v-col
        lg="10"
        cols="12"
      >
        <div class="text-body-1">
          {{
            $t('landingpages.download-tab.upgrade-card.static-tab.body-texts.0', {
              readablePlatformName,
            })
          }}
        </div>
        <div class="my-4 upgrade-list">
          <div class="mb-2 text-body-1 font-weight-bold">
            {{ $t('landingpages.download-tab.upgrade-card.static-tab.body-texts.1') }}
          </div>
          <UpgradeItemList
            :items="[
              $t('labels.templates.upgrade-items.0'),
              $t('labels.templates.upgrade-items.1'),
              $t('labels.templates.upgrade-items.2'),
              $t('labels.templates.upgrade-items.3'),
            ]"
          />
        </div>
        <div class="text-body-1">
          {{ $t('landingpages.download-tab.upgrade-card.shared') }}
        </div>
      </v-col>
    </UpgradeCard>
  </div>
</template>

<script>
import brandingMixin from '@/mixins/branding'

import MATERIALS_FILTERED from '../materialsFiltered.gql'
import UpgradeCard from '../UpgradeCard.vue'
import UpgradeItemList from '../UpgradeItemList.vue'
import StaticCard from './StaticCard.vue'

export default {
  components: {
    StaticCard,
    UpgradeCard,
    UpgradeItemList,
  },
  mixins: [brandingMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      materials: [],
    }
  },
  computed: {
    isLight() {
      return this.company?.productType === 'LIGHT'
    },
    campaignsWithMaterials() {
      return this.campaigns
        .map((campaign) => ({
          campaign,
          materials: this.getRenderableMaterials(campaign.id),
        }))
        .filter(({ materials }) => materials.length > 0)
    },
  },
  methods: {
    getRenderableMaterials(campaignId) {
      return this.materials.filter(
        (material) => material.campaignId === campaignId && this.hasRenderableFiles(material)
      )
    },
    hasRenderableFiles(material) {
      return material.hasFile && material.files?.some((materialFile) => materialFile?.file?.cdnUrl)
    },
  },
  apollo: {
    materials: {
      query: MATERIALS_FILTERED,
      skip() {
        return !this.campaigns?.length
      },
      variables() {
        return {
          input: {
            companyId: this.$auth.user.companyId,
            campaignIds: this.campaigns.map((campaign) => campaign.id),
          },
        }
      },
    },
  },
}
</script>
